import { render, staticRenderFns } from "./BackhaulCustomer.vue?vue&type=template&id=420ae8dc&scoped=true"
import script from "./BackhaulCustomer.vue?vue&type=script&lang=js"
export * from "./BackhaulCustomer.vue?vue&type=script&lang=js"
import style0 from "./BackhaulCustomer.vue?vue&type=style&index=0&id=420ae8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ae8dc",
  null
  
)

export default component.exports